// The "Clip-Short vs <tool>" pages (vs.<id> in i18n/routes.js), clipping tools first. Each page loads its
// own file only (App.tsx), as the guides do; COMPARE_NAMES is all the footer and the sibling links need.
export const COMPARE_IDS = ['opus-clip', 'klap', 'vizard', 'submagic', 'quso', '2short-ai', 'descript', 'veed', 'captions', 'crayo', 'munch', 'invideo-ai'];

export const COMPARE_NAMES = {
  'opus-clip': 'Opus Clip',
  klap: 'Klap',
  vizard: 'Vizard',
  submagic: 'Submagic',
  quso: 'Quso',
  '2short-ai': '2short.ai',
  descript: 'Descript',
  veed: 'VEED',
  captions: 'Captions',
  crayo: 'Crayo',
  munch: 'Munch',
  'invideo-ai': 'InVideo AI',
};

export const COMPARE_LOADERS = {
  'opus-clip': () => import('./opusClip.js'),
  klap: () => import('./klap.js'),
  vizard: () => import('./vizard.js'),
  submagic: () => import('./submagic.js'),
  quso: () => import('./quso.js'),
  '2short-ai': () => import('./twoShort.js'),
  descript: () => import('./descript.js'),
  veed: () => import('./veed.js'),
  captions: () => import('./captions.js'),
  crayo: () => import('./crayo.js'),
  munch: () => import('./munch.js'),
  'invideo-ai': () => import('./invideo.js'),
};

/** Every page's copy, every language: for the tests, llms-full and nothing the browser loads. */
export async function loadAllCompare() {
  const entries = await Promise.all(COMPARE_IDS.map(async (id) => [id, (await COMPARE_LOADERS[id]()).default]));
  return Object.fromEntries(entries);
}

/** The path segment of each page: /compare/clip-short-vs-<slug>, /es/comparar/..., /pt/comparar/... */
export const compareSlug = (id) => `clip-short-vs-${id}`;
